<template>
  <v-autocomplete
    color="secondary"
    no-data-text="Nenhum resultado encontrado"
    :disabled="disabled"
    :value="value"
    :items="items"
    :search-input.sync="search"
    :item-text="onText"
    :item-value="onValue"
    :label="label"
    :placeholder="placeholder"
    :error-messages="currentError"
    :multiple="multiple"
    :return-object="returnObject"
    :class="{ 'gray--text text--lighten-1': disabled }"
    :loading="loading"
    @change="change">
      <span slot="label" :class="{ 'gray--text text--lighten-1': disabled, 'required-field': isRequired }">
        {{ label }}
      </span>
  </v-autocomplete>
</template>

<script>
export default {
  name: 'AppAutoComplete',
  data: () => ({
    search: ''
  }),
  props: {
    value: {
      type: [String, Object, Array]
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    items: {
      type: Array
    },
    onText: {
      type: String,
      default: () => 'title'
    },
    onValue: {
      type: String,
      default: () => 'value'
    },
    returnObject: {
      type: Boolean,
      default: () => false
    },
    multiple: {
      type: Boolean,
      default: () => false
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    v: {
      type: Object,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    currentError () {
      return this.$formErrors(this.v)[0]
    },
    isRequired () {
      return this.v
        ? this.v.hasOwnProperty('required')
        : false
    }
  },
  methods: {
    change (value) {
      if (this.v) this.v.$touch()
      this.$emit('input', value)
      this.$emit('change', value)
    }
  },
  watch: {
    value: function () {
      if (!this.value) {
        this.$emit('input', null)
      }
    }
  }
}
</script>
